module.exports = __webpack_public_path__ + "static/media/Eterno_Thumbnails.51.65ea507a.png";